import styled, { keyframes } from "styled-components";

import { GrayColors } from "@smartsuite/types";

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 15px;
  background-color: ${GrayColors["G-0"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 8px;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
`;

export const StyledIcon = styled.div<{ isExpanded: boolean }>`
  display: flex;
  transition: transform 100ms ease-in;
  transform: rotate(${(props) => (props.isExpanded ? 0 : "-90")}deg);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const StyledChildren = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 23px;
  animation: ${fadeSlideIn} 180ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
